export const tabs = [
  'E-Sign',
  'Privacy',
  'Service & Terms',
  'Information',
  'Pick-up Card'
];
